<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Document Presets</h1>
            <ol class="breadcrumb" id="breadcrumbNav" style="margin-bottom:10px;padding:0px 15px;">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-list"></i>
                    <span>Document Presets</span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container" cdkDropListGroup>
    <div class="component-content col-lg-4" style="height:100%;">
        <preset-list class="model-association-list"></preset-list>
    </div>
    <div class="component-content col-lg-4" style="height:100%;">
        <documentselection></documentselection>
    </div>
    <div class="component-content col-lg-4" style="height:100%;">
        <document-list [association]="true"></document-list>
    </div>
</div>

<recommended></recommended>